// Third-party Library
import { Upload } from "antd";
import { CloudUploadOutlined } from "@ant-design/icons";

// Constants
import { TEMPLATE } from "../../../../../../constants";

import { ButtonLink } from "../../../../../../components";

// Handler Library
import { xlsxHDLR, uploadHDLR, filter } from "../../../../../../handlers";

// Services Library

// Styles 
import classes from "../../index.module.css";

const { Dragger } = Upload;
const { EMPLOYEE_MANAGEMENT_TITLE_BY_NAME, EMPLOYEE_INDEX} = TEMPLATE.EMPLOYEE;
const { equalHDLR } = filter

const UploadTemplate = ({ setSrcData }) => {
  const handleFile = (file) => {
    uploadHDLR.decodeFile(file, (d) => {
      const ftData = xlsxHDLR.readXLSXFile(d);

      const oRawData = ftData.map((ftd) => Object.fromEntries(Object.entries(ftd).map((d) => [EMPLOYEE_MANAGEMENT_TITLE_BY_NAME[d[0]], d[1].toString(),])));
      // attributes mentioned one-by-one, since the xlsx converter not giving any attribute for undefined data
      const oData = equalHDLR.objectEqual2(oRawData, EMPLOYEE_INDEX).map((o, i) => ({...o, key: i}));
      setSrcData(oData);
    });
  };

  return (
    <>
      <Dragger
        accept=".xlsx, .xls"
        multiple={false}
        beforeUpload={(file) => {
          handleFile(file);
          return false;
        }}
      >
        <CloudUploadOutlined style={{ fontSize: "3em" }} />
        <p className={classes["tagline-upload"]}>
          <span className={classes["text-container"]}>
            Drag file to upload or{"\u00a0"}<ButtonLink>browse</ButtonLink>
          </span>
        </p>
        <p style={{ color: "#A4A4A4" }}>XLS or CSV</p>
      </Dragger>
    </>
  );
};

export default UploadTemplate;
